import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=46acce16&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"
import style0 from "./appMain.vue?vue&type=style&index=0&id=46acce16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46acce16",
  null
  
)

export default component.exports